// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'd3a9056b7fa5fc9fdcf00b7e22436ecd7208c31e';
export const BUILD_NUMBER = '267';
export const BUILD_TIMESTAMP = '2026-10-16T06:09:06.966Z';
